import { SimpleQuestionAnswer } from 'types/enums';

/**
 * @description
 * Takes in a boolean or null parameter
 * Condition checked to return either "yes", "no", or ""
 * This function is meant only for a SimpleQuestionAnswer ToggleButtonGroup component
 */
export const getSimpleQAValue = (value: boolean | null | undefined) => {
  if (value == null) return '';

  return value ? SimpleQuestionAnswer.Yes : SimpleQuestionAnswer.No;
};
